import { useMutation } from '@tanstack/react-query';

import createCrudService from '@core/api/create-crud-service';
import { queryClient } from '@core/api/query-client';
import { request } from '@core/api/request';
import { QUERY_KEYS } from '@constants/query-keys';

import type { TBaseQuery } from '@shared/types/base-query';
import type { TReminderTemplate } from '@shared/types/reminder-template';

export type TReminderTemplateQuery = {
  channel?: string;
  status?: string;
  content_type?: string;
  created_by?: number | string;
} & TBaseQuery;

type TReminderTemplatePayload = {
  attachments: number[];
  name: string;
  content: string;
  channel: TReminderTemplate['channel'];
  content_type: TReminderTemplate['content_type'];
  status?: TReminderTemplate['status'];
  category: TReminderTemplate['category'];
  variables: Record<string, string>;
  sid?: string;
  language: string;
  rejection_reason?: string;
};

const reminderTemplateApi = {
  ...createCrudService<
    TReminderTemplate,
    TReminderTemplateQuery,
    TReminderTemplatePayload
  >({
    queryKey: [QUERY_KEYS.getReminderTemplates],
    url: 'reminders/templates',
  }),

  useSync() {
    return useMutation({
      mutationFn: async ({ id }: { id: string | number }) => {
        return await request({
          url: `reminders/templates/${id}/sync/`,
          method: 'POST',
        });
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.getReminderTemplates],
        });
      },
    });
  },
};

export default reminderTemplateApi;
